module.exports = __webpack_public_path__ + "img/symbol_0.4e2d5dd9.png";